app.ui.registerUi('projectPreview', function (app) {
    return {
        implementationExists: function () {
            return location.pathname.split("/").filter(function (parts) { return parts != "" }).pop() === "preview";
        },
        onLoaded: function (data) {
            if (data.hasJustLoaded(RESOURCE_NAME__DOM)) {
                this.init();
            }
        },
        init: function ($scope) {
            if (!this.implementationExists()) return;

            var allowNavigationOn = [
                ".li-edit > a",
                "a.finish-preview",
                ".gsm-close-btn",
                ".flag-and-text-wrap"
            ].join(", ");

            // navigation to disable
            var navigationTargets = $("a").not(allowNavigationOn);
            navigationTargets.click(function (e) {
                e.preventDefault();
            });
            navigationTargets.addClass("preview-navigation-disabled")
                .attr("aria-disabled", "true")
                .attr("title", "");
        }
    };
});